/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { useRef } from 'react';
import useIsomorphicLayoutEffect from './useLayoutEffect.js';
import './dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-7dce2c26.js';
import './easing.js';

var useUpdateEffect = function useUpdateEffect(callback, dependency) {
  var ref = useRef(false);
  useIsomorphicLayoutEffect(function () {
    if (!ref.current) {
      ref.current = true;
      return void 0;
    }
    return callback();
  }, dependency);
};

export { useUpdateEffect as default };
//# sourceMappingURL=useUpdateEffect.js.map
